import { buildValidations, validator } from 'ember-cp-validations';
import { computed } from '@ember/object';
import { fragment } from 'ember-data-model-fragments/attributes';
import { isoDateFormat } from 'client-portal/utils/date-time';
import { reads } from '@ember/object/computed';
import { tracked } from '@glimmer/tracking';
import Model, { attr, belongsTo, hasMany } from '@ember-data/model';
import classic from 'ember-classic-decorator';

const Validations = buildValidations({
  memberId: [
    validator('presence', {
      presence: true,
      descriptionKey: 'errors.insuranceInfo.memberId',
      messageKey: 'errors.presence',
    }),
  ],
  insuredRelation: [
    validator('presence', {
      presence: true,
      descriptionKey: 'errors.insuranceInfo.insuredRelation',
      messageKey: 'errors.presence',
    }),
  ],
  insuredFname: [
    validator('presence', {
      presence: true,
      descriptionKey: 'errors.insuranceInfo.insuredFname',
      messageKey: 'errors.presence',
      disabled: reads('model.selfInsured'),
    }),
  ],
  insuredLname: [
    validator('presence', {
      presence: true,
      descriptionKey: 'errors.insuranceInfo.insuredLname',
      messageKey: 'errors.presence',
      disabled: reads('model.selfInsured'),
    }),
  ],
  insuredDob: [
    validator('presence', {
      presence: true,
      descriptionKey: 'errors.insuranceInfo.insuredDob',
      messageKey: 'errors.presence',
      disabled: reads('model.selfInsured'),
    }),
  ],
  insuredPhone: [
    validator('presence', {
      presence: true,
      descriptionKey: 'errors.insuranceInfo.insuredPhone',
      messageKey: 'errors.presence',
      disabled: reads('model.selfInsured'),
    }),
  ],
  insuredAddress: [
    validator('presence', {
      presence: true,
      descriptionKey: 'errors.insuranceInfo.insuredAddress',
      messageKey: 'errors.presence',
      disabled: reads('model.selfInsured'),
    }),
  ],
  insuredCity: [
    validator('presence', {
      presence: true,
      descriptionKey: 'errors.insuranceInfo.insuredCity',
      messageKey: 'errors.presence',
      disabled: reads('model.selfInsured'),
    }),
  ],
  insuredState: [
    validator('presence', {
      presence: true,
      descriptionKey: 'errors.insuranceInfo.insuredState',
      messageKey: 'errors.presence',
      disabled: reads('model.selfInsured'),
    }),
  ],
  insuredZip: [
    validator('presence', {
      presence: true,
      descriptionKey: 'errors.insuranceInfo.insuredZip',
      messageKey: 'errors.presence',
      disabled: reads('model.selfInsured'),
    }),
  ],
  insurancePlan: [
    validator('presence', {
      presence: true,
      descriptionKey: 'errors.insuranceInfo.insurancePlan',
      messageKey: 'errors.presence',
    }),
  ],
});

@classic
export default class InsuranceInfoModel extends Model.extend(Validations) {
  @belongsTo('treatable-client', { polymorphic: true, async: false, inverse: 'insuranceInfos' })
  client;
  @belongsTo('insurance-provider-name', { async: false, inverse: null }) insurancePlan;
  @hasMany('document', { async: false, inverse: null }) documents;

  @attr() thisType;
  @attr() memberId;
  @attr() planId;
  @attr() groupId;
  @attr() insuredRelation;
  @attr() insuredFname;
  @attr() insuredMname;
  @attr() insuredLname;
  @attr('moment', { format: isoDateFormat }) insuredDob;
  @attr() insuredPhone;
  @attr() insuredAddress;
  @attr() insuredCity;
  @attr() insuredState;
  @attr() insuredZip;
  @attr() createdAt;
  @fragment('insurance-info/coverage-status') coverageStatus;

  @tracked isDirty = false;

  get hasRequiredFields() {
    return this.memberId && this.insuredRelation !== null && this.insurancePlan;
  }

  get validInsuranceCards() {
    return this.documents.filter(card => !card.get('isMarkedForDeletion'));
  }

  @computed('insuredRelation')
  get selfInsured() {
    return this.insuredRelation === '0';
  }
}
